export enum AttendeeStatusEnum {
    ResponseUnknown = 0,
    Organizer = 1,
    Tentative = 2,
    Accept = 3,
    Decline = 4,
    NotResponded = 5,
}
